// Which row actions a shipment permits — mirrors what the delete route itself rejects.

const hasLinks = (row) =>
  Number(row?.totalContractsLinked) > 0 || Number(row?.totalDeclarationsLinked) > 0;

export const SHIPMENT_ACTIONS = Object.freeze({
  // The server refuses to delete a shipment with a contract or a declaration linked.
  delete: { disabled: hasLinks },
});

/**
 * Handlers, each (row) => void:
 *   onAddAttachment · onEdit · onDelete
 */
export const buildShipmentMenuActions = (t, handlers) => [
  // TODO: Link declarations to be added later
  { id: 'add-attachment', label: t('ACTION_ADD_ATTACHMENT'), onClick: handlers.onAddAttachment },
  { id: 'edit', label: t('COMMON_EDIT'), onClick: handlers.onEdit },
  {
    id: 'delete',
    label: t('COMMON_DELETE'),
    disabled: SHIPMENT_ACTIONS.delete.disabled,
    onClick: handlers.onDelete,
  },
];

// The same menu against one row, for a surface that isn't <Table> — RowActionsMenu's item shape.
export const resolveShipmentMenuItems = (actions, row) =>
  actions.map((action) => ({
    id: action.id,
    label: action.label,
    disabled: Boolean(action.disabled?.(row)),
    onSelect: () => action.onClick(row),
  }));
